import React, { useMemo } from 'react';
import { convertToDollarValue } from 'v3/utils/formatter';
import Text from 'v3/components/Text';
import Card from 'v3/components/Card';
import { percentage } from 'utils/number';
import { USD_PRECISION, useFreightValues } from '../../context';
import ValueDetailsRow from '../../components/ValueDetailsRow';

export default function SummaryPayingTransporterCardShow() {
  const { balance, totalShipmentDiscounts, totalShipmentTransfer, erpExchangeValue, advanceMoney } =
    useFreightValues();

  const totalValueToPay = useMemo(() => {
    const total =
      Number(balance?.value) + totalShipmentTransfer?.total - totalShipmentDiscounts?.total;
    return {
      total,
      totalDollarValue: convertToDollarValue(total, erpExchangeValue, USD_PRECISION),
    };
  }, [
    balance?.value,
    balance?.dollarValue,
    totalShipmentDiscounts,
    erpExchangeValue,
    totalShipmentTransfer,
  ]);

  const totalBalance = useMemo(() => {
    const total =
      totalValueToPay?.total - percentage(advanceMoney?.percentage || 0, balance?.value || 0);

    return {
      total,
      totalDollarValue: convertToDollarValue(total, erpExchangeValue, USD_PRECISION),
    };
  }, [
    totalValueToPay,
    advanceMoney?.percentage,
    erpExchangeValue,
    balance?.value,
    balance?.dollarValue,
  ]);

  return (
    <Card containerCardBoxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
      <Text as="p" className="label">
        Resumo a pagar ao transportador
      </Text>
      <>
        <ValueDetailsRow
          label="Total a pagar"
          value={totalValueToPay?.total || 0}
          dollarValue={totalValueToPay?.totalDollarValue || 0}
        />
        <ValueDetailsRow
          label="% adiantamento"
          value={percentage(advanceMoney?.percentage, balance?.value) || 0}
          dollarValue={percentage(advanceMoney?.percentage, balance?.dollarValue)}
          percentageValue={advanceMoney?.percentage || 0}
        />
        <ValueDetailsRow
          weight={600}
          color="success"
          label="Saldo"
          value={totalBalance?.total || 0}
          dollarValue={totalBalance?.totalDollarValue || 0}
        />
      </>
    </Card>
  );
}
